import { countriesBase } from '../lib';
import { getRandomElementFromArray } from '../../../../../utils';

export function generateRandomCountry(): string {
    return getRandomElementFromArray(countriesBase);
}
